import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getStores, createStore, updateStore, deleteStore } from '../api';

function Stores() {
  const navigate = useNavigate();
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [formData, setFormData] = useState({ name: '', address: '', monthly_target: '10000', owner_username: '', owner_password: '123456', owner_nickname: '', owner_phone: '', icon: '🏪', description: '', phone: '', business_hours: '', latitude: '', longitude: '' });

  useEffect(() => { fetchStores(); }, []);

  const fetchStores = async () => {
    try {
      setLoading(true);
      const res = await getStores();
      if (res.data.success) setStores(res.data.data);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('[商户] 提交数据:', formData);
    console.log('[商户] editItem:', editItem);
    try {
      if (editItem) {
        console.log('[商户] 更新门店:', editItem.id, formData);
        await updateStore(editItem.id, formData);
      } else {
        console.log('[商户] 创建门店:', formData);
        await createStore(formData);
      }
      setShowModal(false);
      resetForm();
      fetchStores();
    } catch (e) {
      console.error('[商户] 提交失败:', e);
      alert(e.response?.data?.message || e.message);
      return; // Don't close modal on error
    }
  };

  const handleEdit = (item) => {
    setEditItem(item);
    setFormData({
      name: item.name,
      address: item.address || '',
      monthly_target: item.monthly_target || '10000',
      owner_username: item.owner_username || '',
      owner_password: '123456',
      owner_nickname: item.owner_nickname || '',
      owner_phone: item.owner_phone || '',
      icon: item.icon || '🏪',
      description: item.description || '',
      phone: item.phone || '',
      business_hours: item.business_hours || '',
      latitude: item.latitude || '',
      longitude: item.longitude || ''
    });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('确定删除该商户？删除商户将同时删除对应店长账号。')) {
      try {
        await deleteStore(id);
        fetchStores();
      } catch (e) {
        alert(e.response?.data?.message || '删除失败');
      }
    }
  };

  const resetForm = () => {
    setEditItem(null);
    setFormData({ name: '', address: '', monthly_target: '10000', owner_username: '', owner_password: '123456', owner_nickname: '', owner_phone: '', icon: '🏪', description: '', phone: '', business_hours: '', latitude: '', longitude: '', status: 'active' });
  };

  return (
    <div className="content-card">
      <div className="section-title">商户管理</div>

      <div className="toolbar-row">
        <div></div>
        <button className="action-btn btn-blue" onClick={() => { resetForm(); setShowModal(true); }}>+ 添加商户</button>
      </div>

      {loading ? <div className="loading-text">加载中...</div> : (
        <table className="basic-table">
          <thead>
            <tr>
              <th className="no-cell">序号</th>
              <th>商户名称</th>
              <th>商户地址</th>
              <th>店长昵称</th>
              <th>月度目标</th>
              <th>特色描述</th>
              <th>联系电话</th>
              <th>营业时间</th>
              <th>创建日期</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            {stores.length > 0 ? stores.map((s, i) => (
              <tr key={s.id}>
                <td className="no-cell">{i + 1}</td>
                <td>{s.name}</td>
                <td>{s.address || '-'}</td>
                <td>{s.owner_nickname || '-'}</td>
                <td>¥{(s.monthly_target || 10000).toLocaleString()}</td>
                <td>{s.description || '-'}</td>
                <td>{s.phone || '-'}</td>
                <td>{s.business_hours || '-'}</td>
                <td>{s.created_at?.split('T')[0] || '-'}</td>
                <td>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <button className="btn-xs btn-blue" onClick={() => handleEdit(s)}>编辑</button>
                    <button className="btn-xs btn-red" onClick={() => handleDelete(s.id)}>删除</button>
                  </div>
                </td>
              </tr>
            )) : (
              <tr><td colSpan="7" style={{ textAlign: 'center', color: '#999' }}>暂无数据</td></tr>
            )}
          </tbody>
        </table>
      )}

      {showModal && (
        <div className="modal-mask">
          <div className="modal-box" onClick={e => e.stopPropagation()}>
            <div className="modal-title">
              <span>{editItem ? '编辑门店' : '添加门店'}</span>
              <span className="modal-close" onClick={() => setShowModal(false)}>×</span>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-content">
                <div className="form-tip">带 <span style={{color:'#ff4d4f'}}>*</span> 号的为必填项</div>
                <div className="form-section-title">门店信息</div>
                <div className="form-row">
                  <div className="form-field">
                    <label className="form-label">门店名称 *</label>
                    <input className="form-input" value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} required />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-field">
                    <label className="form-label">门店地址 *</label>
                    <input className="form-input" value={formData.address} onChange={e => setFormData({...formData, address: e.target.value})} required />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-field">
                    <label className="form-label">月度目标(元)</label>
                    <input className="form-input" type="number" value={formData.monthly_target} onChange={e => setFormData({...formData, monthly_target: e.target.value})} />
                  </div>
                </div>
                <div className="form-section-title">小程序展示信息</div>
                <div className="form-row">
                  <div className="form-field">
                    <label className="form-label">店铺特色描述</label>
                    <input className="form-input" value={formData.description} onChange={e => setFormData({...formData, description: e.target.value})} placeholder="4-8个字，如：中医养生" maxLength={8} />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-field">
                    <label className="form-label">联系电话</label>
                    <input className="form-input" value={formData.phone} onChange={e => setFormData({...formData, phone: e.target.value})} placeholder="用于小程序展示" />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-field">
                    <label className="form-label">营业时间</label>
                    <input className="form-input" value={formData.business_hours} onChange={e => setFormData({...formData, business_hours: e.target.value})} placeholder="如：9:00-21:00" />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-field">
                    <label className="form-label">门店图标</label>
                    <input className="form-input" value={formData.icon} onChange={e => setFormData({...formData, icon: e.target.value})} placeholder="默认🏪" />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-field">
                    <label className="form-label">经纬度</label>
                    <div style={{display: 'flex', gap: '8px'}}>
                      <input className="form-input" value={formData.latitude} onChange={e => setFormData({...formData, latitude: e.target.value})} placeholder="纬度" style={{flex: 1}} />
                      <input className="form-input" value={formData.longitude} onChange={e => setFormData({...formData, longitude: e.target.value})} placeholder="经度" style={{flex: 1}} />
                    </div>
                  </div>
                </div>
                
                {!editItem && (
                  <>
                    <div className="form-section-title">店长账号（创建后自动生成）</div>
                    <div className="form-row">
                      <div className="form-field">
                        <label className="form-label">店长手机号 *</label>
                        <input className="form-input" value={formData.owner_phone} onChange={e => setFormData({...formData, owner_phone: e.target.value})} placeholder="用于登录，11位手机号" required pattern="1[3-9]\d{9}" />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-field">
                        <label className="form-label">初始密码</label>
                        <input className="form-input" value={formData.owner_password} onChange={e => setFormData({...formData, owner_password: e.target.value})} placeholder="默认为123456，留空则使用默认值" />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-field">
                        <label className="form-label">店长昵称</label>
                        <input className="form-input" value={formData.owner_nickname} onChange={e => setFormData({...formData, owner_nickname: e.target.value})} placeholder="留空则使用手机号" />
                      </div>
                    </div>
                  </>
                )}

                {editItem && editItem.owner_username && (
                  <>
                    <div className="form-section-title">店长账号信息</div>
                    <div className="form-row">
                      <div className="form-field">
                        <label className="form-label">店长手机号</label>
                        <input className="form-input" value={editItem.owner_username || ''} disabled />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-field">
                        <label className="form-label">重置密码</label>
                        <input className="form-input" value={formData.owner_password} onChange={e => setFormData({...formData, owner_password: e.target.value})} placeholder="留空则不修改" />
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="form-field">
                        <label className="form-label">店长昵称</label>
                        <input className="form-input" value={formData.owner_nickname} onChange={e => setFormData({...formData, owner_nickname: e.target.value})} />
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="modal-foot">
                <button type="button" style={{ marginRight: 12 }} onClick={() => setShowModal(false)}>取消</button>
                <button type="submit" className="action-btn btn-blue">保存</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Stores;